
import { Component, Vue } from 'nuxt-property-decorator'
import SynergyPopup from '~/components/popups/SynergyPopup.vue'

interface availableText {
  type: 'artist'|'artCritic'|'gallery'|'showroom'|'curator'|'business'|'',
  title: string,
  textList: string[],
  features: string[]
}

@Component({
  components: { SynergyPopup }
})
export default class extends Vue {
  head () {
    return {
      title: 'ArtHall.Synergy',
      meta: [
        { hid: 'og:title', name: 'og:title', content: 'ArtHall.Synergy' },
        { hid: 'og:image', name: 'og:image', content: require('~/assets/img/logo-black.svg') },
        { hid: 'og:type', name: 'og:type', content: 'website' },
        { hid: 'og:url', name: 'og:url', content: process.env.API_ENDPOINT + this.$route.fullPath }
      ]
    }
  }

  isShowForm = false
  choiceType = ''
  availableTextList:availableText[] = [
    {
      type: 'artist',
      title: 'Художники',
      textList: [
        'Демонстрируйте свои работы участникам рынка, зрителям, покупателям. Узнайте внутреннюю статистику и процесс оценки ваших работ искусствоведами и зрителями. Художники, набравшие большее количество голосов, получают приглашение в основную галерею ArtHall. Преимущества участия в нашем проекте для вас:'
      ],
      features: [
        'выход на всероссийский и международный уровень',
        'продвижение и продажа работ',
        'получение клиентских заказов картин',
        'бесплатное участие в творческих сообществах, где вы получаете поддержку коллег, делитесь фишками и перенимаете опыт друг друга',
        'предложения от выставочных залов и музеев',
        'экспертизы от искусствоведов',
        'ваши работы увидят арт-менеджеры и искусствоведы России, которые смогут выстроить грамотную стратегию вашего развития, создадут для вас имя и цепляющую зрителей историю - это, то, что будет отличать вас от других и создавать интерес на арт рынке'
      ]
    },
    {
      type: 'artCritic',
      title: 'Искусствоведы',
      textList: [
        'Получите доступ к работам всех художников России, размещайте свои обзоры и получайте заказы на экспертизу коллекции, подбор работ и кураторство, а также:'
      ],
      features: [
        'большой выбор новых художников для анализа, продвижения',
        'размещение материалов',
        'заказы на экспертизу и подбор работ',
        'заказы на организацию выставок',
        'поддержка с организационно-технической частью при проведении вашего мероприятия',
        'заказы на чтение лекций, мастер классов, неформальных встреч для людей, интересующихся искусством',
        'заказы на проведение и тематических мероприятий'
      ]
    },
    {
      type: 'showroom',
      title: 'Музеи и выставочные залы',
      textList: [
        'Создавайте запросы на выставки или выбирайте из имеющихся предложений. Подбирайте работы в коллекцию вашего пространства. Доступные для вас возможности:'
      ],
      features: [
        'размещение запросов на организацию мероприятий',
        'предложения по проведению мероприятий',
        'большой выбор новых художников',
        'разместите промо в виртуальной реальности',
        'заказывайте информационное сопровождение своих мероприятий'
      ]
    },
    {
      type: 'curator',
      title: 'Арт-менеджеры',
      textList: [
        'Подбирайте готовые наборы выставок, предлагайте свои идеи или получайте заказы от галерей и государства. Используйте преимущества совместного сотрудничества:'
      ],
      features: [
        'большой выбор художников',
        'новые искусствоведы',
        'выставочные залы',
        'публикуйте свои предложения для музеев, выставочных залов, отелей и ресторанов',
        'доступ к запросам выставочных залов, бизнеса, государства'
      ]
    },
    {
      type: 'business',
      title: 'Бизнес',
      textList: [
        'Есть потребность в создании привлекательного имиджа для гостей или желание создать необычное оформление вашего зала? Закажите подбор или выбирайте готовую выставку для проведения вашего мероприятия, а также:'
      ],
      features: [
        'закажите организацию и проведение статусного мероприятия или выберите из предлагаемых нами вариантов',
        'организация мастер классов или тематических мероприятий для ваших клиентов (арт завтраки, вечера искусств и тд) с участием профессиональных, харизматичных искусствоведов, которые создадут интеллектуально - эстетичную атмосферу, с первой минуты заинтересуют публику и окунут в мир искусства',
        'если вы представитель ресторанного или гостиничного бизнеса, закажите экспозицию на вашу площадку с целью привлечения гостей, создания нового контента в социальные сети, повышения имиджа и популярности'
      ]
    },
    {
      type: '',
      title: 'Зрители и покупатели',
      textList: [
        'Посмотрите, что происходит в мире искусства. Покупайте, голосуйте, закажите подбор картины или оценку вашей коллекции:'
      ],
      features: [
        'смотрите работы новых художников',
        'посещайте музеи и выставки с технологиями виртуальной реальности',
        'примеряйте картины в собственном интерьере с помощью технологий дополненной реальности',
        'инвестируйте в эксклюзивные объекты искусства',
        'посещайте лекции лучших спикеров онлайн и оффлайн',
        'узнавайте о новых арт событиях в вашем городе'
      ]
    }
  ]
}
